import React from 'react'
import TimelineComponent from '../components/TimelineComponent'

function Schedule() {
  return (
    <>
        <TimelineComponent/>
    </>
  )
}

export default Schedule
